import { Grid, makeStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import CustomCounter from '../../components/CustomCounter'
import { formatNumber, isValidUrl } from '../../shared/constants'
const useStyles = makeStyles((theme) => ({
  counter: {
    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      direction: 'rtl',
      margin: 'auto 0 auto auto',
    },
  },
  detail: {
    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      margin: 'auto',
    },
  },
}))

export default function ProductCard({
  product: tempProduct,
  index,
  filteredProducts,
  classes,
  handleAdd,
  handleSubtract,
  wishList,
  grid,
  setMustProduct = () => {},
}) {
  const classes2 = useStyles()
  const [product, setProduct] = useState(false)

  useEffect(() => {
    if (tempProduct) {
      setProduct(tempProduct)
    }
  }, [tempProduct])
  return (
    <>
      {index % 2 !== 0 && !grid && <Grid item lg={1} />}
      <Grid
        className={`${classes.productGrid} ${
          filteredProducts.length > 1 && (index % 2 == 0 ? classes.evenIndexProduct : classes.oddIndexProduct)
        }`}
        item
        container
        sm={10}
        lg={grid ? grid : index % 2 ? 6 : 5}
      >
        <Grid item lg={4}>
          <div>
            <img
              src={
                isValidUrl(product.primaryImage)
                  ? product.primaryImage
                  : 'https://kohler.scene7.com/is/image/Kohler/KohlerLogoImage?$CorpSecondary$&crop=110,0,23778,16000&wid=590&hei=397'
              }
              height="113px"
              width="134px"
              style={{ borderRadius: '8px' }}
              alt="logo"
            />
          </div>
        </Grid>

        <Grid item lg={4} className={grid && classes2.detail}>
          <div>
            <span style={{ fontSize: '18px' }}>{product.name}</span>
            <br />
            Color: {product.color}
            <br />
            SKU: {product.sku}
            <br />
            {formatNumber(product.dealerPrice)}
          </div>
        </Grid>

        <Grid item lg={4} style={{ margin: '30px 0 0 0' }} className={grid && classes2.counter}>
          {wishList[product._id] ? (
            <CustomCounter
              value={wishList[product._id].quantity}
              handleAdd={() =>
                handleAdd(product._id, product.name, product.primaryImage, product.dealerPrice, product.color)
              }
              handleSubtract={() => handleSubtract(product._id)}
            />
          ) : (
            <div
              onClick={() => {
                handleAdd(
                  product._id,
                  product.name,
                  product.primaryImage,
                  product.dealerPrice,
                  product.color,

                  true
                )
                setMustProduct(product.mustItem)
              }}
              className={classes.addButton}
            >
              Add
            </div>
          )}
        </Grid>
      </Grid>
    </>
  )
}
